<template>
	<div class="hotspot-module" ref="hotspotmod" tabindex="0">
		<div v-for="(scene, index) in castedScenes" :key="scene.DisplayTitle">
			<div class="hotspot-module__scene" v-show="index === activeIndex">
				<HotspotScene
					:key="scene.DisplayTitle"
					:backgroundImage="scene.BackgroundImage"
					:sceneAssociatedColor="scene.SceneAssociatedColor"
					:caption="scene.Caption"
					:captionTitle="scene.CaptionTitle"
					:activeIndex="activeIndex"
					:displayTitle="scene.DisplayTitle"
					:hotspotPlacements="scene.HotSpotPlacements"
					:title="scene.Title"
					:modalVisible="modalVisible"
					@updateActiveHotspotIndex="updateActiveHotspotIndex"
					@modalVisibilityUpdated="modalVisibilityUpdated"
				></HotspotScene>
			</div>
		</div>
	</div>
	<div class="hotspot-scene__tabs">
		<div class="hotspot-scene__tabs-list">
			<SceneTab v-for="(scene, index) in castedScenes" :key="scene.DisplayTitle"
	          :index="index"
	          :scene="scene"
	          :tabName="scene.DisplayTitle"
	          :activeIndex="activeIndex"
	          :sceneAssociatedColor="scene.SceneAssociatedColor"
	          @updateVisibleSceneIndex="updateVisibleSceneIndex"
	          @updateChosenScene="updateChosenScene"
	          @scrollUpdate="scrollUpdate">
			</SceneTab>
		</div>
	</div>
	<Teleport to="body">
		<transition name="fade" appear>
			<HotspotsModal
				v-if="modalVisible"
				@modalVisibilityUpdated="modalVisibilityUpdated">
				<HotspotContent
					:hotspotPlacements="activeScene.HotSpotPlacements"
					:backgroundImage="activeScene.BackgroundImage"
					:activeHotspotIndex="activeHotspotIndex"
					@updateActiveHotspotIndex="updateActiveHotspotIndex">

				</HotspotContent>
			</HotspotsModal>
		</transition>
	</Teleport>
</template>

<script lang="ts" setup>
import {onMounted, ref, computed, watchEffect, onUpdated} from 'vue';
import HotspotScene from 'Vue/components/hotspotComponents/HotspotScene.vue';
import {AdvancedHotspots, Scene} from 'Interfaces/interfaces';
import SceneTab from "Vue/components/hotspotComponents/SceneTab.vue";
import HotspotContent from "Vue/components/hotspotComponents/HotspotContent.vue";
import HotspotsModal from "Vue/components/hotspotComponents/HotspotsModal.vue";
const componentName = 'AdvancedHotspots';
const hotspotData = ref<AdvancedHotspots | null>(null);
const activeIndex = ref<number>(0);
const modalVisible = ref<boolean>(false);
const activeHotspotIndex = ref<number>(0);
const hotspotmod = ref(null);
const topPosition = ref(null);
const activeScene = ref<Scene | null>(null);
const scenes = computed(() => {
	return hotspotData.value?.Scenes || [];
});

const castedScenes = computed(() => {
	return scenes.value.map((scene: any) => scene as Scene);
});

const updateVisibleSceneIndex = (index: number) => {
	activeIndex.value = index;
};

const modalVisibilityUpdated = (value) => {
	modalVisible.value = value;
};

const scrollUpdate = () => {
	// Scroll to the top of the element smoothly
	// if (hotspotmod.value) {
	// 	hotspotmod.value.focus();
	// }


	window.scrollTo({
		top: topPosition.value,
		behavior: 'smooth' // for smooth scrolling
	});
}

const updateChosenScene = (scene) => {
	activeScene.value = scene;
};

const updateActiveHotspotIndex = (indexValue) => {
	activeHotspotIndex.value = indexValue;
}

const handleWindowResize = () => {
	if (hotspotmod.value) {
		topPosition.value = hotspotmod.value.offsetTop;
	}
};

onMounted(() => {
	const element = document.querySelector('.js-advanced-hotspots');
	if (element) {
		const dataAttribute = element.getAttribute('data-hotspotdata');
		if (dataAttribute) {
			hotspotData.value = JSON.parse(dataAttribute) as AdvancedHotspots;
		}
	}

	topPosition.value = hotspotmod.value.offsetTop;

	// Preload images
	castedScenes.value.forEach(scene => {
		const img = new Image();
		img.src = scene.BackgroundImage;
	});

	activeScene.value = castedScenes.value[0];

	updateVisibleSceneIndex(0);
	window.addEventListener('resize', handleWindowResize);


	if ('scrollRestoration' in history) {
		// Back off, browser, I got this...
		history.scrollRestoration = 'manual';
	}
});

</script>
